import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { PutPotentialValue } from "../../../API/AnalysisAPI";
import './styles.css';
import CurrencyInput from 'react-currency-input-field';
import { GrPowerReset } from "react-icons/gr";
import useCan from "../../../Hooks/useCan";

interface IPotentialValueComponent {
    defaultPotentialValue: number,
    analysisId: string,
    setValueHasChanged: React.Dispatch<React.SetStateAction<boolean>>,
    toggleLoading: (data: boolean) => void,
    canNotEdit: boolean,
    userEmail: string,
    companyId: string,
    totalAssets: number
    grossRevenue: number
    netWorth: number,
    hasConcluded: boolean
}

const PotentialValueComponent = (props: IPotentialValueComponent) => {
    const masterCanNotView = useCan({ rolesCan: ["Master"] })
    const CanView = useCan({ rolesCan: ["Manager"] })
    const [potentialValue, setPotentialValue] = useState<number>(props.defaultPotentialValue);
    const [def, setDef] = useState<number>(0);
    const [min, setMin] = useState<number>(props.defaultPotentialValue);
    const RoleAdm = useCan({ rolesCan: ["Administrator"] })

    const updateMin = () => {
        var mathMin = 0;

        if (props.totalAssets == 0) {
            mathMin = Math.min(props.grossRevenue * 0.15, props.netWorth * 0.35);
        } else if (props.grossRevenue == 0) {
            mathMin = Math.min(props.totalAssets * 0.1, props.netWorth * 0.35);
        } else if (props.netWorth == 0) {
            mathMin = Math.min(props.totalAssets * 0.1, props.grossRevenue * 0.15);
        } else {
            mathMin = Math.min(props.totalAssets * 0.1, props.grossRevenue * 0.15, props.netWorth * 0.35);
        }

        if (mathMin == 0) {
            mathMin = Math.max(props.totalAssets * 0.1, props.grossRevenue * 0.15, props.netWorth * 0.35);
        }

        setMin(mathMin);
    }

    const putPotentialValue = async (reset: boolean) => {
        try {
            if (!reset && (props.analysisId == "" || props.defaultPotentialValue == potentialValue)) return;
            props.toggleLoading(true);
            await PutPotentialValue(props.analysisId, reset ? min.toString() : potentialValue.toString(), props.userEmail, props.companyId).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    props.setValueHasChanged(true);
                }
            }).finally(() => props.toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            props.toggleLoading(false);
        }
    }

    useEffect(() => {
        setPotentialValue(props.defaultPotentialValue);
        setDef(props.defaultPotentialValue);
        updateMin();
    }, [props.defaultPotentialValue]);

    return (
        <div className='container-financial-potency mb-3 d-flex align-items-center'>
            <div className='form-control h-100 container-text-financial w-50 border-0 rounded-0 d-flex align-items-center'>
                <span className='font-weight-bold'>Valor Potencial de Financiamento</span>
            </div>
            {props.defaultPotentialValue == def &&
                <div className="border-0 rounded-0 h-100 w-100 container-relative">
                    <CurrencyInput
                        id="input-example"
                        name="input-name"
                        className='form-control h-100 w-100 text-value-pontential'
                        intlConfig={{ locale: 'pt-BR' }}
                        placeholder="0,00"
                        defaultValue={potentialValue}
                        disabled={props.canNotEdit || props.hasConcluded || masterCanNotView}
                        decimalsLimit={2}
                        onValueChange={(value: any, name: any) => setPotentialValue(value ? value : 0)}
                    />
                    {!props.hasConcluded && potentialValue != min && CanView &&
                        <button
                            className="btn button-update button-reset"
                            onClick={() => putPotentialValue(true)}
                        >
                            <GrPowerReset size={20} />
                        </button>
                    }
                    {((props.hasConcluded && !props.canNotEdit) || CanView || RoleAdm) &&
                        <button
                            disabled={props.defaultPotentialValue == potentialValue || potentialValue == undefined || potentialValue == 0}
                            className="btn btn-primary button-update"
                            onClick={() => putPotentialValue(false)}
                        >
                            Atualizar
                        </button>
                    }
                </div>
            }
        </div >
    )
}

export default PotentialValueComponent;